import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// The benign "ResizeObserver loop…" browser notice is swallowed by an inline
// script in public/index.html. It can't be done here: webpack-dev-server's
// error overlay registers its own 'error' listener before this module runs,
// so a listener added from the bundle always fires after it.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
